import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppConfigService } from 'src/environments/app-config.service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ComponentsModule } from './components/components.module';
import { PagesModule } from './pages/pages.module';

import { AuthInterceptor } from './services/auth/http-interceptors/auth.interceptor';
import { AuthService } from './services/auth/auth.service';
import { LoggedinGuard } from './services/auth/security/loggedin.guard';
import { AccessDeniedModule } from './shared/access-denied/access-denied.module';
import { B3DesignSystemWebModule } from './shared/b3-design-system-web/b3-design-system-web.module';
import { AppLoaderService } from './shared/services/app-loader.service';

 const appInitializerFn = (appConfig: AppConfigService) => {
  return () => {
     return appConfig.loadAppConfig();
   };
 };

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ComponentsModule,
    PagesModule,
    AccessDeniedModule,
    B3DesignSystemWebModule,
  ],
  providers: [
    // Angular 21+ e zoneless por padrao; o app ainda depende de Zone.js (subscribe HTTP sem signals/async pipe).
    provideZoneChangeDetection({ eventCoalescing: true }),
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppConfigService]
    },
    AppLoaderService,
    LoggedinGuard,
    AuthService
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
